import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Group_7353",
	"data-name": "Group 7353",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 16,
	height: 12.8,
	viewBox: "0 0 16 12.8",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_3860",
				"data-name": "Rectangle 3860",
				width: 16,
				height: 12.8
			})
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Group_7352",
			"data-name": "Group 7352",
			clipPath: "url(#clip-path)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_19291",
				"data-name": "Path 19291",
				d: "M16,1.6A1.6,1.6,0,0,0,14.4,0H1.6A1.6,1.6,0,0,0,0,1.6v9.6a1.6,1.6,0,0,0,1.6,1.6H14.4A1.6,1.6,0,0,0,16,11.2Zm-1.6,0L8,5.6l-6.4-4Zm0,9.6H1.6v-8L8,7.2l6.4-4Z"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgEmail);
export default ForwardRef;
